<script setup lang="ts">
import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useComponentErrorCapture } from "@/mixins/error";
import { useMenuItems } from "@/mixins/menuItems";

const router = useRouter();
const route = useRoute();
const { getSettingsItems } = useMenuItems();
useComponentErrorCapture();

const menuItems = ref<any[]>([]);

const selectedMenuItem = ref("");
const activeOptionItem = ref({ label: '', value: '' });

watch(router.currentRoute, (to, from) => {
  if (menuItems.value) {
    const menuItem = menuItems.value.find(item => item.value === to.name);
    setMenuItem(menuItem);
  }
});

const hasActiveItem = computed(() => {
  return selectedMenuItem.value.length > 0;
});

function setMenuItem(menuItem: any) {
  if (menuItem) {
    selectedMenuItem.value = menuItem.value;
    activeOptionItem.value.label = menuItem.label;
    activeOptionItem.value.value = menuItem.value;
  } else {
    selectedMenuItem.value = '';
  }
}

function selectMenuItem(value: string, action: string = '') {
  if (action.length > 0) {
    router.push({
      name: value,
      query: {
        action: action,
      }
    });
  } else {
    router.push({ name: value });
  }
  selectedMenuItem.value = value;
};

onMounted(async () => {
  menuItems.value = await getSettingsItems();

  if (window.innerWidth > 992 && router.currentRoute?.value?.name?.toString() == "settings") {
    selectMenuItem("general")
  }

  if (route.query && route.query.action && route.query.action == "software-update") {
    selectMenuItem("general", route.query.action)
  }

  if (menuItems.value) {
    const menuItem = menuItems.value.find(item => item.value === router.currentRoute.value.name);
    setMenuItem(menuItem);
  }
})

</script>
<template>
  <div class="page-settings">
    <div :class="{'page-settings__menu--selected-item' : hasActiveItem}" class="page-settings__menu">
      <div
        v-for="(menuItem, index) in menuItems"
        :key="index"
        @click="selectMenuItem(menuItem.value)"
        :class="{ 'page-settings__menu__item--active': selectedMenuItem === menuItem.value }"
        class="page-settings__menu__item">
        <i :class="menuItem.icon"></i>
        {{ $t(menuItem.label) }}
      </div>
    </div>
    <div class="page-settings__menu-content">
      <RouterView v-slot="{ Component }">
        <Transition name="opacity">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </div>
  </div>
</template>